import { Button, Spacer, SegmentedButton } from '@ontruck/orc';

const getGoogleMapsLinkFromStops = (stops) => {
  const latLngList = (stops || []).map((stop) => ({
    latitude: stop.address?.latitude,
    longitude: stop.address?.longitude,
  }));

  return latLngList.reduce(
    (acc, { latitude, longitude }) => `${acc}${latitude},${longitude}/`,
    'https://www.google.com/maps/dir/'
  );
};

const RoutingMapActions = ({ stops, mapStopFilter = [], onFilterChange }) => {
  return (
    <div className="map-actions">
      <Spacer mRight="S">
        <Button
          href={getGoogleMapsLinkFromStops(stops)}
          target="_blank"
          text="Open in Google Maps"
        />
      </Spacer>
      <SegmentedButton.Parent size="M" name="stopType" onChange={onFilterChange} multi>
        <SegmentedButton.Child
          checked={mapStopFilter.includes('PICKUP')}
          value="PICKUP"
          name="PICKUP"
          label="Pickup"
        />
        <SegmentedButton.Child
          checked={mapStopFilter.includes('DROPOFF')}
          value="DROPOFF"
          name="DROPOFF"
          label="Dropoff"
        />
      </SegmentedButton.Parent>
    </div>
  );
};

export default RoutingMapActions;
